import React from 'react';

export default function () {
  return (
    <svg viewBox="0 0 258 158" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <path
          d="M27.25 4.542c-12.535 0-22.708 10.173-22.708 22.709 0 12.535 10.173 22.708 22.709 22.708 12.535 0 22.708-10.173 22.708-22.708 0-12.536-10.173-22.71-22.708-22.71zm0 26.202l-7.86 7.861-3.494-3.494 7.86-7.86-7.86-7.861 3.494-3.494 7.86 7.86 7.861-7.86 3.494 3.494-7.86 7.86 7.86 7.861-3.494 3.494-7.86-7.86z"
          id="a"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <ellipse
          cx="129.124"
          cy="148.778"
          fill="#F0F1F1"
          rx="59.124"
          ry="8.778"
        />
        <g fill="#BABFC0">
          <g transform="rotate(-180 98.175 34.014)">
            <ellipse cx="2.92" cy="37.926" rx="2.92" ry="2.926" />
            <path d="M13.389 0h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM11.926 35h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852z" />
          </g>
          <g transform="translate(0 27.065)">
            <ellipse cx="2.92" cy="2.926" rx="2.92" ry="2.926" />
            <ellipse cx="64.92" cy="63.926" rx="2.92" ry="2.926" />
            <ellipse cx="43.92" cy="19.926" rx="2.92" ry="2.926" />
            <path d="M20.926 0h61.308v5.852H20.926a2.926 2.926 0 0 1 0-5.852zM75.389 26h6.56v8.778h-6.56a4.389 4.389 0 0 1 0-8.778zM73.926 61h8.023v5.852h-8.023a2.926 2.926 0 0 1 0-5.852zM58.76 35h23.357v17.556H58.759A8.76 8.76 0 0 1 50 43.796v-.037A8.76 8.76 0 0 1 58.76 35z" />
          </g>
        </g>
        <g transform="translate(81.752)">
          <rect fill="#BABFC0" height="122.889" rx="5.839" width="94.891" />
          <rect
            fill="#FFF"
            height="111.185"
            rx="2.92"
            width="83.212"
            x="6"
            y="6"
          />
          <g transform="translate(19 32)">
            <path d="M0 0h54.501v54.501H0z" />
            <mask fill="#fff" id="b">
              <use xlinkHref="#a" />
            </mask>
            <use
              fill="#FFF"
              fillRule="nonzero"
              transform="matrix(1 0 0 -1 0 54.501)"
              xlinkHref="#a"
            />
            <g fill="#FA6428" mask="url(#b)">
              <path d="M0 0h55.015v55.057H0z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
